import { contentfulImageUrl } from '@telialt/utils/src/Contentful/contentfulImageUrl';

import { HeroBannerType } from '../../models/Content';
import { transformCta, transformResponsiveImage } from '../../utils/transformers';
import { HeroBannerContent } from './model';

export const transformHeroBanner = (content: HeroBannerType): HeroBannerContent => {
    const video = content.fields.video;

    return {
        title: content.fields.title,
        preamble: content.fields.subtitle,
        description: content.fields.description,
        legalText: content.fields.legal?.fields.description,
        primaryCta: transformCta(content.fields.primaryCta),
        secondaryCta: transformCta(content.fields.secondaryCta),
        tertiaryCta: transformCta(content.fields.tertiaryCta),
        video: video && {
            videoProps: {
                src: video.fields.file.url,
                poster: contentfulImageUrl(content.fields.videoPoster?.fields.file.url),
                autoPlay: content.fields.autoplayVideo,
                'aria-label': video.fields.description,
            },
            captionProps: {},
            playAriaLabel: content.fields.playVideoAriaLabel,
            pauseAriaLabel: content.fields.pauseVideoAriaLabel,
        },
        images: transformResponsiveImage(content.fields.image),
    };
};
